export const numberMixin = {
    methods: {
        formatNumber (num) {
            return new Intl.NumberFormat('de-DE', { 
                style: 'decimal',
                maximumFractionDigits: 0,
            }).format(num)
        },
        unformatNumber (num) {
            var thousandSeparator = (1111).toLocaleString().replace(/1/g, '');
            var decimalSeparator = (1.1).toLocaleString().replace(/1/g, '');
        
            return parseFloat(num.toString()
                .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
                .replace(new RegExp('\\' + decimalSeparator), '.')
            );
        }
    }
} 